import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export function useProfileFormValidation() {
  const { t } = useTranslation();
  return yup.object({
    title: yup.string().trim().required(t('manageShippingProfiles.editor.title.required')),
    rates: yup
      .array()
      .of(
        yup.object({
          destinationKey: yup
            .string()
            .required(t('manageShippingProfiles.editor.destination.required')),
          priceUsd: yup
            .string()
            .required(t('manageShippingProfiles.editor.price.required'))
            .test('positive-number', t('manageShippingProfiles.editor.price.invalid'), value => {
              if (!value) {
                return false;
              }
              const num = parseFloat(value);
              return !isNaN(num) && num >= 0;
            }),
        })
      )
      .min(1),
  });
}
